
var reviews = document.getElementById('product-reviews');

var reviewContent = Array.from(document.getElementsByClassName('spr-reviews'));
var reviewToggle = false;

function toggleReviews(){

  if (reviewToggle){
    reviewContent[0].classList.add('reviews__show');
  } else{
    reviewContent[0].classList.remove('reviews__show');
  }

  console.log(reviewContent[0])
}

//This is a workaround becuase for some reason I cant just get the button by class name?????
document.addEventListener('click', function(e){
  if (e.target.classList[0] == 'spr-summary-actions-togglereviews'){
    reviewToggle = !reviewToggle
    toggleReviews();
  }
})